module.exports = __webpack_public_path__ + "b56119e5c97c1f923b2aceb147602e12.pdf";